import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import NiceModal from "@ebay/nice-modal-react";
import App from "./App";
import { AuthProvider } from "./contexts/useAuth";
import reportWebVitals from "./reportWebVitals";

// Wrap the app in BrowserRouter to access Route
// Wrap the app in AuthProvidor to access useAuth
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <BrowserRouter>
    <AuthProvider>
      <NiceModal.Provider>
        <App />
      </NiceModal.Provider>
    </AuthProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
